import React from 'react';

import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import EditorialBand from '../../components/public/EditorialBand.component';
import EditorialBulletList from '../../components/public/EditorialBulletList.component';
import EditorialHero from '../../components/public/EditorialHero.component';
import EditorialJourney from '../../components/public/EditorialJourney.component';
import {
  GROUP_ORDER_HERO,
  GROUP_ORDER_JOURNEY,
  GROUP_ORDER_SUPPORT,
} from '../../constants/group-order-content.constants';
import Meta from '../../../utils/metaDescription';

const useStyles = makeStyles({
  supportTitle: {
    fontFamily: 'Bitter, serif',
    fontWeight: 700,
    fontSize: 'clamp(1.5rem, 4vw, 2.1rem)',
    lineHeight: 1.2,
    marginBottom: '1.5rem',
    textAlign: 'center',
    color: '#fff',
  },
  support: {
    maxWidth: '42rem',
    margin: '0 auto',
  },
});

const GroupOrderView: React.FC = () => {
  const classes = useStyles();

  return (
    <React.Fragment>
      {/* La page legacy est la seule du lot à n'avoir aucune balise SEO. */}
      <Meta page="commandgroup" />

      <EditorialBand ground="cream" underFloatingNav>
        <EditorialHero title={GROUP_ORDER_HERO.title} />
      </EditorialBand>

      <EditorialBand ground="plain">
        <EditorialJourney steps={GROUP_ORDER_JOURNEY} />
      </EditorialBand>

      <EditorialBand ground="solid">
        <Typography component="h2" className={classes.supportTitle}>
          {GROUP_ORDER_SUPPORT.title}
        </Typography>

        <div className={classes.support}>
          <EditorialBulletList items={GROUP_ORDER_SUPPORT.points} onSolid />
        </div>
      </EditorialBand>
    </React.Fragment>
  );
};

export default GroupOrderView;
